import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const verifyAdmin = () => {
  return new Promise(async (resolve, reject) => {
    const token = localStorage.getItem("token");
    if (token) {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      try {
        const response = await axios.get(`${BASE_URL}/auth/verify`, config);
        if (response.data.success === false) {
          localStorage.removeItem("token");
          reject(false);
        } else {
          resolve(true);
        }
      } catch (err) {
        localStorage.removeItem("token");
        reject(false);
      }
    } else {
      reject(false);
    }
  });
};

export { verifyAdmin };
